<template>
    <div class="contactCreate scroll-container">
        <div class="contactCreate-list">
            <div class="privacy-layout">
              <privacy-button v-if="isPrivacy" @privacy-switch="reload" :refresh="refresh" type="btn-mini"></privacy-button>
            </div>
            <form>
                <div class="passenger-detail-desc">
                    <div class="passenger-content" @click="showSelector">
                        <div class="passenger-family">国家或地区</div>
                        <div class="passenger-txt nationality-txt">
                            <div class="css_nationality js_nationality">{{countryText ? countryText : nationTip}}</div>
                        </div>
                        <div class="passenger-arrow-right"></div>
                    </div>
                    <div class="passenger-content">
                        <div class="passenger-family">中文姓</div>
                        <div class="passenger-txt">
                            <input type="text" class="lastName" data-key="ChineseLastName" @focus="txtFocus" v-model="currentData.chineseLastName" placeholder="必填" @change="pyName('lastName',
                            currentData.chineseLastName)">
                        </div>
                        <div class="passenger-family">中文名</div>
                        <div class="passenger-txt">
                            <input type="text" placeholder="必填" data-key="ChineseFirstName" @focus="txtFocus" v-model="currentData.chineseFirstName" class="firstName" @change="pyName('firstName',
                            currentData.chineseFirstName)">
                        </div>
                    </div>
                    <div class="passenger-content">
                        <div class="passenger-family">姓拼音</div>
                        <div class="passenger-txt"><input type="text" data-key="PinYinLastName" @focus="txtFocus" placeholder="必填" v-model="currentData.pinYinLastName" class="lastNamePY"></div>
                        <div class="passenger-family">名拼音</div>
                        <div class="passenger-txt"><input type="text" data-key="PinYinFirstName" @focus="txtFocus" placeholder="必填" v-model="currentData.pinYinFirstName" class="firstNamePY"></div>
                    </div>
                    <div class="passenger-content">
                        <div class="passenger-family">性别</div>
                        <div class="passenger-txt passenger-male">
                            <div class="male-txt" v-bind:class="{active: currentData.gender === 'M'}" @click="selectGender('M')"><i></i><span>男</span></div>
                            <div class="female-txt" v-bind:class="{active: currentData.gender === 'F'}" @click="selectGender('F')"><i></i><span>女</span></div>
                            <div class="passenger-placeholder">必选</div>
                        </div>
                    </div>
                    <div class="passenger-content passenger-birthDate">
                        <div class="passenger-family">出生日期</div>
                        <div class="passenger-txt">
                            <input type="text" placeholder="必填" data-key="DateOfBirth" v-model="currentData.dateOfBirth" class="birthOfDate input-text-left">
                        </div>
                        <img src="https://resource.rcclchina.com.cn/tui2/user_center/calender-icon.png">
                    </div>
                    <div class="passenger-optional">
                        <div class="optionalContent" v-if="isUnfold">
                            <div class="passenger-content">
                                <div class="passenger-family">手机号码</div>
                                <div class="passenger-txt"><input maxlength="11" type="text" placeholder="" data-key="Telephone" @focus="txtFocus" v-model="currentData.telephone"
                                                                  class="telephone input-text-left"></div>
                            </div>
                            <div class="passenger-content">
                                <div class="passenger-family">护照号</div>
                                <div class="passenger-txt">
                                    <input type="text" placeholder="" v-model="currentData.passPortNum" data-key="PassPortNum" @focus="txtFocus" class="passportNum input-text-left">
                                </div>
                            </div>
                            <div class="passenger-content passenger-pssport">
                                <div class="passenger-family">护照有效期至</div>
                                <div class="passenger-txt">
                                    <input type="text" placeholder="" v-model="currentData.passPortExpirationDate" data-key="PassPortExpirationDate" class="passportDate input-text-left">
                                </div>
                                <img src="https://resource.rcclchina.com.cn/tui2/user_center/calender-icon.png">
                            </div>
                            <div class="passenger-content">
                                <div class="passenger-family">电子邮箱</div>
                                <div class="passenger-txt"><input type="text" placeholder="" v-model="currentData.email" data-key="Email" @focus="txtFocus" class="email input-text-left"></div>
                            </div>
                        </div>
                        <div class="optionalTxt" @click="opeOptional">
                            <div class="optionTxt-close" v-if="!isUnfold">
                                展开（选填）<img src="https://resource.rcclchina.com.cn/tui2/user_center/arrow-down.png">
                            </div>
                            <div class="optionTxt-open" v-else>
                                收起（选填） <img src="https://resource.rcclchina.com.cn/tui2/user_center/arrow-down.png">
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <div class="contact-default">
            <div class="contact-default-title">保存为默认联系人</div>
            <div class="contact-default-switch">
                <label class="switch">
                    <input type="checkbox" v-model="currentData.isDefaultContact">
                    <span class="slider round"></span>
                </label>
            </div>
        </div>
        <div class="contactCreate-addGuestBtn" @click="save">保存</div>

        <CountrySelector ref="countrySelector" :isShow="isShowCountrySelector" :onCountrySelected="selectCountry" :onCountryClose="closeSelector"></CountrySelector>
    </div>
</template>

<script>
    import api from '@/api'
    import { objLen, delayDev } from '@/utilities/tools'
    import CountrySelector from '@/components/Booking/CountrySelector.vue'
    import 'pickerjs/dist/picker.css'
    import Picker from 'pickerjs'
    const PrivacyButton = () => import('@/components/Common/PrivacyButton')
    export default {
        name: 'Contact',
        components: {
            CountrySelector,
            PrivacyButton
        },
        props: {
            prevData: {
                type: Object,
                default: () => {
                    return null
                }
            },
            nationTip: {
                type: String,
                default: '必填'
            },
            isPrivacy: {
              type: Boolean,
              default: false
            }
        },
        data: () => {
            return {
                isUnfold: false,
                countryText: '',
                currentData: {
                    userName: '',
                    id: '',
                    country: '',
                    chineseLastName: '',
                    chineseFirstName: '',
                    pinYinLastName: '',
                    pinYinFirstName: '',
                    gender: '',
                    dateOfBirth: '',
                    telephone: '',
                    passPortNum: '',
                    passPortExpirationDate: '',
                    email: '',
                    isDefaultContact: ''
                },
                currentDataOriginal: {},
                isShowCountrySelector: false,
                birthPicker: null,
                passportExpirePicker: null,
                updateFields: [],
                refresh: null
            }
        },
        watch: {
            'prevData' (newVal) {
                this.initData(newVal)
            }
        },
        beforeMount () {
            this.init()
        },
        methods: {
            reload() {
              this.$emit('reload')
            },
            async initData (data) {
                // 国家列表
                const countryList = await this.getCountry()
                this.$store.commit('SET_COUNTRIES', countryList)
                if (objLen(data) > 0) {
                    this.currentData.userName = this.$store.state.user.userToken
                    this.currentData.id = data.id
                    this.currentData.country = data.country
                    this.currentData.chineseLastName = data.chineseLastName
                    this.currentData.chineseFirstName = data.chineseFirstName
                    this.currentData.pinYinLastName = data.pinyinLastName
                    this.currentData.pinYinFirstName = data.pinyinFirstName
                    this.currentData.gender = data.gender
                    this.currentData.dateOfBirth = data.dateOfBirth
                    this.currentData.telephone = data.telephone
                    this.currentData.passPortNum = data.passportNum
                    this.currentData.passPortExpirationDate = data.passportExpirationDate
                    this.currentData.email = data.email
                    this.currentData.isDefaultContact = data.isDefaultContact
                    this.currentDataOriginal = Object.assign({}, this.currentData);
                    const countryItem = countryList.find(item => data.country === item.countryCode)
                    if (countryItem) {
                        this.countryText = countryItem.countryName
                    }
                }
                // this.initBirthPickerDate();
            },
            async init () {
                // 国家列表
                const countryList = await this.getCountry()
                this.$store.commit('SET_COUNTRIES', countryList)
                // if(this.prevData === null) this.initBirthPickerDate();
                this.initBirthPickerDate();
            },
            initBirthPickerDate() {
              // picker实例化
              let birthPickerDate = {data: Date.now(), format: 'YYYY-MM-DD'};
              if(this.currentData.dateOfBirth) {
                birthPickerDate = this.isMaskValue ? {data: Date.now(), format: 'YYYY-MM-DD'} : this.currentData.dateOfBirth;
              }
              this.birthPicker = this.initPicker('.birthOfDate', birthPickerDate, () => {
                let pickerDate = this.birthPicker.getDate(true)
                let pickerTime = new Date(pickerDate).getTime()
                let currentTime = new Date().getTime()
                if (pickerTime > currentTime) {
                  this.currentData.dateOfBirth = ''
                  this.$alert.show('请选择正确的出生日期')
                } else {
                  if(!this.updateFields.includes("DateOfBirth")) {
                    this.updateFields.push("DateOfBirth");
                  }
                  this.currentData.dateOfBirth = pickerDate
                }
              })
            },
            save () {
              this.currentData.updateFields = this.updateFields;
              this.$emit('on-save', this.currentData)
            },
            opeOptional () {
                this.isUnfold = !this.isUnfold
                if (this.isUnfold) {
                    delayDev(200, () => {
                        this.passportExpirePicker = this.initPicker('.passportDate', this.currentData.passPortExpirationDate, () => {
                            let pickerDate = this.passportExpirePicker.getDate(true)
                            let pickerTime = new Date(pickerDate).getTime()
                            let currentTime = new Date().getTime()
                            if (pickerTime < currentTime) {
                                this.currentData.passPortExpirationDate = ''
                                this.passportExpirePicker.update()
                                this.$alert.show('请选择正确的护照有效期')
                            } else {
                                if(!this.updateFields.includes("PassPortExpirationDate")) {
                                  this.updateFields.push("PassPortExpirationDate");
                                }
                                this.currentData.passPortExpirationDate = pickerDate
                            }
                        })
                    })
                } else {
                    this.passportExpirePicker.destroy()
                }
            },
            async pyName (key, value) {

                if (!value || value.length == 0) return
                const { data } = await api.page.getPinyin(value)
                if (data && data.length > 0) {
                    if (key == 'firstName') {
                        this.currentData.pinYinFirstName = data
                    } else if (key == 'lastName') {
                        this.currentData.pinYinLastName = data
                    }
                }
            },
            selectGender (gender) {
                this.currentData.gender = gender
                if(!this.updateFields.includes("Gender")) {
                  this.updateFields.push("Gender")
                }
            },
            showSelector () {
                this.isShowCountrySelector = true
            },
            selectCountry (countryCode) {
                let countries = this.$store.state.page.countries
                let item = countries.find(item => item.countryCode === countryCode)
                this.countryText = item.countryName
                this.currentData.country = countryCode

                if(!this.updateFields.includes("Country")) {
                  this.updateFields.push("Country")
                }
                // 关闭浮层
                this.isShowCountrySelector = false
            },
            closeSelector () {
                this.isShowCountrySelector = false
            },
            async getCountry () {
                const {success, data, errMsg} = await api.user.userEditInfo()
                if (!success) {
                    console.log(errMsg)
                    return null
                } else {
                    return data.nationalityApiViews
                }
            },
            initPicker (selector, date, pick) {
                return new Picker(document.querySelector(selector), {
                    format: 'YYYY-MM-DD',
                    text: {
                        title: '请选择出生日期(年/月/日)',
                        cancel: '取消',
                        confirm: '确认'
                    },
                    date,
                    pick
                });
            },
            txtFocus(e) {
              let dataKey = e.target.getAttribute('data-key')
              if(this.isMaskValue) {
                if(dataKey === 'ChineseLastName' || dataKey === 'PinYinLastName') {
                  if(!this.updateFields.includes("ChineseLastName") || !this.updateFields.includes("PinYinLastName")) {
                    this.currentData.chineseLastName = "";
                    this.currentData.pinYinLastName = "";
                    this.updateFields.push("ChineseLastName");
                    this.updateFields.push("PinYinLastName");
                  }
                }

                if (dataKey === 'ChineseFirstName' || dataKey === 'PinYinFirstName') {
                  if(!this.updateFields.includes("ChineseFirstName") || !this.updateFields.includes("PinYinFirstName")) {
                    this.currentData.chineseFirstName = "";
                    this.currentData.pinYinFirstName = "";
                    this.updateFields.push("ChineseFirstName");
                    this.updateFields.push("PinYinFirstName");
                  }
                }

                // if(dataKey === 'PassPortExpirationDate') {
                //   if(!this.updateFields.includes("PassPortExpirationDate")) {
                //     this.currentData.passPortExpirationDate = "";
                //     this.updateFields.push("PassPortExpirationDate");
                //   }
                // }
                //
                // if(dataKey === 'DateOfBirth') {
                //   if(!this.updateFields.includes("DateOfBirth")) {
                //     this.currentData.dateOfBirth = "";
                //     this.updateFields.push("DateOfBirth");
                //   }
                // }

                if(!this.updateFields.includes(dataKey)) {
                  Object.keys(this.currentData).filter(r => {
                    if (dataKey.toUpperCase() === r.toUpperCase()) {
                      this.currentData[r] = "";
                      return r
                    }
                  });
                }
              }
              if(dataKey !== 'PassPortExpirationDate' && dataKey !== 'DateOfBirth') {
                if (!this.updateFields.includes(dataKey)) {
                  this.updateFields.push(dataKey);
                }
              }
            }
        },
      computed: {
        isMaskValue() {
          return this.$store.state.page.isMaskValue;
        }
      }
    }
</script>

<style lang="less" scoped>
    /**** 常用联系人添加页面****/
    .contactCreate{
        padding: 50px 0;
    }
    .noborder{
        border:none !important;
    }
    .page-content{
        margin-top:2.2rem;
        padding-bottom:8.2rem;
        background-color:#f1f1f1;
        position:relative;
    }
    nav.home-bar-nav {
        background-color:#061556;
    }
    .contactCreate-list {
        background-color:#fff;
        padding:0 12px;
    }
    .contactCreate-list ul{
        list-style:none;
        padding:0;
        margin:0;
    }
    .contactCreate-list ul li{
        border-bottom:1px solid #e0e0e0;
        padding:13px 11px;
    }
    .contactCreate-list .contactCreate-item {
        position:relative;
    }
    .contactCreate-list .contactCreate-item span{
        font-size:13px;
        color:#989898;
    }
    .contactCreate-list .contactCreate-item input {
        margin-left: 20px;
        font-size: 13px;
        color: #000;
        padding: 6px 0;
        text-indent: 4px;
        border: none;
        outline: none;
        -webkit-appearance: none;
        background-color: transparent;
    }

    input.birthOfDate {
        width: 240px;
        position: relative;
        z-index: 1;
    }

    input.passportDate {
        width: 190px;
        position: relative;
        z-index: 1;
    }

    .contactCreate-list .contactCreate-item input::-webkit-input-placeholder {
        color: #999999;
    }
    .contactCreate-list .contactCreate-item .calendarIcon {
        position:absolute;
        right:15px;
        top:0;
        width:24px;
        height:24px;
    }
    .contactCreate-list .contactCreate-item .calendarIcon img{
        width:100%;
    }
    .contactCreate-list .contactCreate-item .contactCreate-itemSex{
        margin-right:32px;
    }
    .contactCreate-list .contactCreate-item .item-sex{
        margin-right:41px;
    }
    .contactCreate-list .contactCreate-item .item-sex{
        color:#000;
    }
    .contactCreate-list .contactCreate-item .item-sex .f7-icons{
        color:#7e7e7e !important;
        font-size:21px !important;
        vertical-align:top;
        margin-right:11px;
    }
    .contactCreate-list .contactCreate-item .item-sex .f7-icons.active{
        color:#0073a0 !important;
    }
    .contactCreate-addGuestBtn {
        background-image: linear-gradient(270deg, #FAD961 0%, #FEBC10 100%);
        font-family: PingFang-SC-Medium;
        font-size: 16px;
        color: #454545;
        letter-spacing: 2.5px;
        padding:11px 0;
        margin:24px 0px 0 0px;
        text-align:center;
        position:relative;
    }

    /**** 20180705 ****/
    .passenger-detail-desc{
        background:#fff;
        padding:0 10px;
        position: relative;
    }
    .passenger-content{
        width: 100%;
        border-bottom:1px solid #e8e8e8;
        padding:10px 0;
        position: relative;
        font-size:14px;
        display:flex;
    }
    .passenger-content .passenger-family,
    .passenger-content .passenger-txt {
        display: inline-block;
        font-size: 14px;
        height: 35px;
        line-height: 38px;

    }
    .passenger-family {
        margin-right: 15px;
    }
    .nationality-txt {
        -webkit-box-flex: 1;
        -webkit-flex: 1;
        -moz-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        position: relative;
        padding-right: 10px;
    }
    input::-webkit-input-placeholder {
        color: #999;
    }
    .passenger-content .passenger-family{
        font-family: PingFang-SC-Medium;
        font-size: 14px;
        color: #333333;
        letter-spacing: 0;
        max-width:141px;
        overflow:hidden;
        vertical-align:top;
    }
    .passenger-content .passenger-txt input {
        color: #000;
        outline: none;
        border: none;
        height:35px;
        width: 250px;
        background-color: transparent;
        -webkit-appearance: none;
        position: relative;
        z-index: 1;
        text-align: center;
    }
    .passenger-arrow-right {
        position: absolute;
        right: 0;
        top: 50%;
        -webkit-transform: translateY(-50%) rotate(-45deg);
        -moz-transform: translateY(-50%) rotate(-45deg);
        -ms-transform: translateY(-50%) rotate(-45deg);
        -o-transform: translateY(-50%) rotate(-45deg);
        transform: translateY(-50%) rotate(-45deg);
        width: 10px;
        height: 10px;
        border-right: 1px solid #4A90E2;
        border-bottom: 1px solid #4A90E2;
    }
    .passenger-content .passenger-txt input.lastName,
    .passenger-content .passenger-txt input.firstName,
    .passenger-content .passenger-txt input.lastNamePY,
    .passenger-content .passenger-txt input.firstNamePY{
        width:100px;
        height:35px;
        overflow:hidden;
    }
    .passenger-content .passenger-txt input.birth-date {
        width: 224px;
    }
    .passenger-optional .optionalTxt {
        text-align:center;
        font-size:12px;
        padding:10px 0;
        font-family: PingFang-SC-Medium;
        color: #999999;
        letter-spacing: 0.86px;
    }

    .optionalTxt img {
        width: 11px;
        position: relative;
    }

    .optionTxt-open img {
        transform: rotate(180deg);
        top: -2px;
    }

    .passenger-content .passenger-txt input#contacts-address {
        width: 230px;
    }
    .passenger-content .passenger-txt .passport-validity{
        width:220px;
    }
    .passenger-txt .male-txt,
    .passenger-txt .female-txt{
        display:inline-block;
    }
    .passenger-txt .male-txt i,
    .passenger-txt .female-txt i{
        width: 15px;
        height: 15px;
        display:inline-block;
        background:url("https://resource.rcclchina.com.cn/tui2/user_center/list-unselected.png") no-repeat;
        vertical-align:middle;
        background-size: 100% 100%;
        position: relative;
        top: -1px;
    }
    .passenger-content .passenger-male{
        padding-left:50px;
    }

    .passenger-placeholder {
        font-family: PingFang-SC-Medium;
        font-size: 14px;
        color: #999999;
        letter-spacing: 0.86px;
    }

    .passenger-male .passenger-placeholder{
        margin-left: 34px;
        display: inline-block;
        vertical-align: middle;
    }

    .passenger-txt .male-txt span,
    .passenger-txt .female-txt span{
        margin-left:10px;
    }
    .passenger-birthDate,
    .passenger-pssport{
        position:relative;
    }
    .passenger-txt .male-txt{
        margin-right:30px;
    }
    .passenger-content .passenger-txt .active i{
        background:url("https://resource.rcclchina.com.cn/tui2/user_center/list-selected.png") no-repeat;
        background-size: 100% 100%;
    }
    .passenger-birthDate img,
    .passenger-pssport img{
        width:20px;
        position:absolute;
        top: 16px;
        right: 5px;
        z-index: 0;
    }
    #pinyinBtn {
        background: #fff;
        color: #006bb9;
        padding: 5px;
        border: 1px solid;
        border-radius: 6px;
        font-size: 12px;
        width: 50px;
        text-align: center;
        position: absolute;
        top: 13px;
        right: 10px;
    }
    /****---- 清空护照号 ----****/
    .passportClearBtn {
        color: #006bb9;
        border: 1px solid;
        border-radius: 6px;
        font-size: 12px;
        width: 46px;
        line-height: 28px;
        text-align: center;
        position: absolute;
        top: 13px;
        right: 10px;
    }
    .passenger-content .passenger-txt input.birthOfDate {
        width: 270px;
        position: relative;
        top: -2px;
        padding-top: 0px;
        height: 100%;
    }

    .passenger-content .passenger-txt .input-text-left {
        text-align: left;
        padding-left: 20px;
    }

    .passenger-content .passenger-txt .passportDate {
        width: 242px;
        position: relative;
        top: -2px;
        padding-top: 0px;
        height: 100%;
    }

    .passenger-content .passenger-txt  .passportNum {
        padding-left: 35px;
    }

    .passenger-content .passenger-txt .vipNum {
        padding-left: 8px;
    }

    /**contact default**/
    .contact-default {
        background-color: white;
        margin-top: 9px;
        width: 100%;
        height: 50px;
        padding: 16px 20px;
        font-family: PingFang-SC-Medium;
        font-size: 14px;
        color: #333333;
    }


    .contact-default>div {
        display: inline-block;
        vertical-align: top;
        position: relative;
    }

    .contact-default-switch {
        float: right;
    }

    .contact-default-title {
        top: -2px;
    }

    /*toggle switch*/
    /* The switch - the box around the slider */
    .switch {
        position: relative;
        display: inline-block;
        width: 31px;
        height: 16px;
    }

    /* Hide default HTML checkbox */
    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    /* The slider */
    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: .4s;
        transition: .4s;
        background: #FFFFFF;
        border: 1px solid #CCCCCC;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 15px;
        width: 15px;
        left: -2px;
        bottom: -1px;
        -webkit-transition: .4s;
        transition: .4s;
        background: #FFFFFF;
        border: 1px solid #CCCCCC;
        box-shadow: 0 1px 2.5px 0 rgba(0,0,0,0.30);
    }

    input:checked + .slider {
        background-color: #2196F3;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px #2196F3;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(16px);
        -ms-transform: translateX(16px);
        transform: translateX(16px);
    }

    /* Rounded sliders */
    .slider.round {
        border-radius: 34px;
    }

    .slider.round:before {
        border-radius: 50%;
    }

    .privacy-layout {
      font-size: 0;
      line-height: 1;
      text-align: right;
      padding-top: 0.45rem;
    }
</style>
